import { Layout, ConfigurationData as ConfigurationDataComponent } from "components"
export const ConfigurationData = () => {
 return (
  <Layout>
   <ConfigurationDataComponent />
  </Layout>
 )
}
